<script lang="ts">
    import CriteriaPanelistsPage from '@Evaluation/CriteriaSurveys/Pages/CriteriaPanelistsPage'
    export default CriteriaPanelistsPage
</script>

<template>
    <div>
        <CriteriaSurveyAccessLinks :viewModel="criteriaSurveyAccessLinks"
                                   @show-email-sender="showCriteriaSurveyEmailSender"
                                   @download-links="handleDownloadAccessLinks" />

        <CriteriaSurveyEmailSender :viewModel="criteriaSurveyEmailSender"
                                   @send-email="handleSendEmailCommand" />

        <CriteriaPanelistsManager v-if="criteriaPanelistsManager"
                                  :viewModel="criteriaPanelistsManager"
                                  @include-panelist="handleIncludeCriteriaPanelistCommand" />

        <PanelistConsistencyAnalysisDialog :propOpened="panelistConsistencyAnalysisOpened === true" :propRm="panelistConsistencyAnalysis"
                                           @close-dialog="panelistConsistencyAnalysisOpened = false" />

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div v-if="Initialized" class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h6>
                        <a class="text-dark" v-sanitizedHref="url_Criteria_WeightsPage">
                            <i class="fa fa-angle-double-left" aria-hidden="true"></i> Back to criteria panels
                        </a>
                    </h6>
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">
                        Panelists: {{SurveyName}} ({{Progress}}%)
                    </h1>
                </div>
                <div class="col-lg-6 text-right mt-auto">
                    <button role="button" class="btn btn-outline-secondary mr-1" style="padding: 0.7em 2em;" @click="DownloadLinksCommand">Access links</button>
                    <button role="button" class="btn btn-success" style="padding: 0.7em 2em;" @click="AddPanelistsCommand">Add panelists</button>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 60px;" />

        <div class="container">

            <h3 v-if="!Initialized"><i class="fa fa-spinner fa-spin"></i> Loading... </h3>

            <div v-if="Initialized">
                <nav class="navbar navbar-light navbar-expand-md bg-light" role="navigation">
                    <form class="form-inline mr-2">
                        <div class="btn-group">
                            <button type="button" class="btn btn-outline-secondary btn-sm" v-if="NonePanelistsSelected" @click="SelectAllCommand"><i class="fa-regular fa-square"></i></button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" v-if="AnyPanelistsSelected && !AllPanelistsSelected" @click="UnselectAllCommand"><i class="fa fa-square-minus"></i></button>
                            <button type="button" class="btn btn-outline-secondary btn-sm" v-if="AllPanelistsSelected" @click="UnselectAllCommand"><i class="fa-regular fa-square-check"></i></button>
                            <button type="button" class="btn btn-outline-secondary btn-sm dropdown-toggle dropdown-toggle-split" data-toggle="dropdown"></button>
                            <div class="dropdown-menu">
                                <a class="dropdown-item" @click="SelectAllCommand">All</a>
                                <a class="dropdown-item" @click="UnselectAllCommand">None</a>
                                <a class="dropdown-item" @click="InverseSelectionCommand">Inverse</a>
                            </div>
                        </div>
                    </form>
                    <form class="form-inline mr-auto">
                        <button type="button" class="btn btn-sm" :class="[NonePanelistsSelected ? 'btn-outline-secondary' : 'btn-outline-primary']" :disabled="NonePanelistsSelected" @click="EmailManyCommand">
                            Send email ({{SelectedPanelistsCount}})
                        </button>
                    </form>
                    <form class="form-inline my-2 my-lg-0 mr-2">
                        <div class="dropdown">
                            Filter: <a class="text-primary font-weight-bold dropdown-toggle" data-toggle="dropdown">{{FilterLabel}}</a>
                            <div class="dropdown-menu dropdown-menu-right">
                                <a class="dropdown-item my-2" @click="resetFilters()">
                                    <span>All panelists</span>
                                </a>
                                <div class="dropdown-divider"></div>
                                <h6 class="dropdown-header">By progress:</h6>
                                <a class="dropdown-item my-2" @click="filterByProgress('Not started')">
                                    <span>Not started</span>
                                </a>
                                <a class="dropdown-item my-2" @click="filterByProgress('In progress')">
                                    <span>In progress</span>
                                </a>
                                <a class="dropdown-item my-2" @click="filterByProgress('Completed')">
                                    <span>Completed</span>
                                </a>
                                <h6 class="dropdown-header">By tag:</h6>
                                <a class="dropdown-item" v-for="t in tags" @click="filterByTag(t)">{{t}}</a>
                            </div>
                        </div>
                    </form>
                    <form class="form-inline my-2 my-lg-0" role="search">
                        <input class="form-control form-control-sm mr-sm-2" type="search" placeholder="Search" v-model="SearchPhrase">
                    </form>
                </nav>
                <br />
                <div class="row">
                    <div class="col">
                        <table class="table table-hover">
                            <tbody>
                                <tr v-for="p in PanelistsView" :key="p.ProjectUserId">
                                    <td style="width: 32px;" class="align-middle">
                                        <input type="checkbox" v-model="p.IsSelected" style="width: 16px; height: 16px;">
                                    </td>
                                    <td>
                                        <p class="fg-color-gray mb-0 mt-1">
                                            <span>{{p.Name}}</span>
                                        </p>
                                        <small class="text-muted" v-if="p.HasEmail">{{p.Email}}</small>
                                        <small class="text-danger" v-if="!p.HasEmail">Email not provided</small>
                                    </td>
                                    <td style="width: 150px;" class="align-middle">
                                        <div class="dropdown" v-if="!p.IsDeleted">
                                            <a class="text-primary" data-toggle="dropdown">Vote strength: {{p.VoteStrength}}</a>
                                            <div class="dropdown-menu" role="menu">
                                                <a class="dropdown-item" @click="handleChangeCriteriaPanelistVoteStrengthCommand(p, 0);">Vote strength: 0</a>
                                                <a class="dropdown-item" @click="handleChangeCriteriaPanelistVoteStrengthCommand(p, 1);">Vote strength: 1</a>
                                                <a class="dropdown-item" @click="handleChangeCriteriaPanelistVoteStrengthCommand(p, 2);">Vote strength: 2</a>
                                                <a class="dropdown-item" @click="handleChangeCriteriaPanelistVoteStrengthCommand(p, 3);">Vote strength: 3</a>
                                                <a class="dropdown-item" @click="handleChangeCriteriaPanelistVoteStrengthCommand(p, 4);">Vote strength: 4</a>
                                                <a class="dropdown-item" @click="handleChangeCriteriaPanelistVoteStrengthCommand(p, 5);">Vote strength: 5</a>
                                                <a class="dropdown-item" @click="handleChangeCriteriaPanelistVoteStrengthCommand(p, 6);">Vote strength: 6</a>
                                                <a class="dropdown-item" @click="handleChangeCriteriaPanelistVoteStrengthCommand(p, 7);">Vote strength: 7</a>
                                                <a class="dropdown-item" @click="handleChangeCriteriaPanelistVoteStrengthCommand(p, 8);">Vote strength: 8</a>
                                                <a class="dropdown-item" @click="handleChangeCriteriaPanelistVoteStrengthCommand(p, 9);">Vote strength: 9</a>
                                                <a class="dropdown-item" @click="handleChangeCriteriaPanelistVoteStrengthCommand(p, 10);">Vote strength: 10</a>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item" @click="handleExcludePanelistsCommand(p)">Exclude</a>
                                            </div>
                                        </div>
                                        <a class="text-primary" v-if="p.IsDeleted" @click="handleExcludePanelistsCommand(p)">Exclude</a>
                                    </td>

                                    <td class="align-middle" style="width: 120px;">
                                        <div class="progress" style="margin: 0;">
                                            <div :style="{ 'width': `${p.Progress}%` }" :title="`${p.Progress}%`" class="progress-bar progress-bar-success progress-bar-striped" role="progressbar"></div>
                                        </div>
                                    </td>

                                    <td style="width: 30px;" class="align-middle">
                                        <ConsistencyAnalysisCircles v-if="!p.IsDeleted" class="pointer"
                                                                    :status="p.ConsistencyAnalysisStatus" :size="1"
                                                                    @show-consistency-analysis="showConsistencyAnalysis(p.ProjectUserId)" />
                                    </td>

                                    <td class="align-middle" style="width: 120px;">
                                        <div class="dropdown">
                                            <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">
                                                Actions
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a class="dropdown-item" v-sanitizedHref="`/#/weighting/dashboard/${workspaceId}/${surveyId}/${p.ProjectUserId}`" target="_blank">Review</a>
                                                <a class="dropdown-item" @click="EmailOneCommand(p)">Email</a>
                                                <div class="dropdown-divider"></div>
                                                <a class="dropdown-item" @click="handleExcludePanelistsCommand(p)">Exclude</a>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
